/**
 * Builds the default coaching check-in message a manager sends to a flagged
 * teammate. Pure + dependency-free on purpose: the client uses it to prefill the
 * editable preview, and the server uses it as the fallback when the manager
 * sends without edits — one source of truth for the wording.
 *
 * The tone stays supportive and never quotes raw "X pts below team avg" numbers;
 * the rep should feel coached, not graded. `tag` is "down" (declining trend) or
 * "warn" (low score).
 */
export function buildCheckInDraft({ name, tag = "warn" } = {}) {
  const first = (name || "").trim().split(" ")[0] || "there";

  if (tag === "down") {
    return [
      `Hi ${first},`,
      "",
      "I was looking over your recent practice sessions and wanted to check in. Your scores have dipped a little lately - that happens to everyone, and it's a great moment to regroup. Let's find time to run through a few reps together and rebuild your momentum.",
      "",
      "Reply here if anything is getting in the way - happy to help.",
      "",
      "Thanks!",
    ].join("\n");
  }

  return [
    `Hi ${first},`,
    "",
    "I wanted to check in on your sales practice. I'd love to help you push your scores higher - a few focused reps can make a real difference. Let's set aside some time to work through a scenario or two together.",
    "",
    "Reply here and let me know what works for you.",
    "",
    "Thanks!",
  ].join("\n");
}
